import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {
  EQChangeRequest,
  changeRequestListParams,
} from "../../models/serverModels/workOrder/EQChangeRequest";

const rootApi = process.env.REACT_APP_API_KEY;

const changeRequest = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: changeRequestListParams
): Promise<ResponseList<EQChangeRequest>> =>
  changeRequest({
    url: "/ChangeRequestList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQChangeRequest>> =>
  changeRequest({
    url: `/ChangeRequest/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const create = async (
  params: Params.Create<EQChangeRequest>
): Promise<ResponseItem<EQChangeRequest>> =>
  changeRequest({
    url: `/ChangeRequest`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  changeRequest({
    url: `/ChangeRequest/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQChangeRequest>
): Promise<ResponseItem<EQChangeRequest>> =>
  changeRequest({
    url: `/ChangeRequest/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
